module.exports = __webpack_public_path__ + "img/device_notification.aa9953ab.svg";